"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoteCommentsService = void 0;
class NoteCommentsService {
    constructor(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * returns a list of an auditable model note comments
     * @param modelName
     * @param refId
     * @param noteId
     * @param page
     * @param count
     * @returns ListNoteCommentsRes
     * @throws ApiError
     */
    listNoteComments(modelName, refId, noteId, page, count) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/notes/{modelName}/comments/{refId}/{noteId}',
            path: {
                'modelName': modelName,
                'refId': refId,
                'noteId': noteId,
            },
            query: {
                'page': page,
                'count': count,
            },
        });
    }
    /**
     * create an auditable model new note comment
     * @param modelName
     * @param refId
     * @param noteId
     * @param requestBody
     * @returns NotesCommentResponse
     * @throws ApiError
     */
    createNoteComment(modelName, refId, noteId, requestBody) {
        return this.httpRequest.request({
            method: 'POST',
            url: '/notes/{modelName}/comments/{refId}/{noteId}',
            path: {
                'modelName': modelName,
                'refId': refId,
                'noteId': noteId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * update an auditable model note comment
     * @param modelName
     * @param commentId
     * @param requestBody
     * @returns NotesCommentResponse
     * @throws ApiError
     */
    updateNoteComment(modelName, commentId, requestBody) {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/notes/{modelName}/comments/{commentId}',
            path: {
                'modelName': modelName,
                'commentId': commentId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * delete an auditable model note comment
     * @param modelName
     * @param commentId
     * @returns any Successful response
     * @throws ApiError
     */
    deleteNoteComment(modelName, commentId) {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/notes/{modelName}/comments/{commentId}',
            path: {
                'modelName': modelName,
                'commentId': commentId,
            },
        });
    }
}
exports.NoteCommentsService = NoteCommentsService;
